import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TablePagination from '@material-ui/core/TablePagination'
import TableRow from '@material-ui/core/TableRow'
import classes from './editableTable.module.css'
import Attached from '../modal/attached'
import axios from 'axios'

const columns = [
  { id: 'crfNo', label: 'CRF#', minWidth: 170 },
  { id: 'dateCreated', label: 'Date created', minWidth: 100 },
  {
    id: 'amountRequested',
    label: 'Amount Requested',
    minWidth: 170,
    align: 'right'
    // format: (value) => value.toLocaleString('en-US'),
  },
  {
    id: 'queueNo',
    label: 'Queue no',
    minWidth: 170,
    align: 'right'
    // format: (value) => value.toLocaleString('en-US'),
  },
  {
    id: 'fileName',
    label: 'Filename',
    minWidth: 170,
    align: 'right'
    // format: (value) => value.toFixed(2),
  },
  {
    id: 'action',
    label: 'Actions',
    minWidth: 170,
    align: 'right'
    // format: (value) => value.toFixed(2),
  }
]

function createData (
  crfNo,
  dateCreated,
  amountRequested,
  queueNo,
  fileName,
  action
) {
  return { crfNo, dateCreated, amountRequested, queueNo, fileName, action }
}

const useStyles = makeStyles({
  root: {
    width: '100%'
  },
  container: {
    maxHeight: 440
  }
})
const formatDate = date => {
  const dateArray = date.split('-')
  let month = dateArray[1]
  const day = dateArray[2].substring(0, 2)
  const year = dateArray[0]
  switch (dateArray[1]) {
    case '02':
      month = 'Feb'
      break
    case '03':
      month = 'Mar'
      break
    case '04':
      month = 'Apr'
      break
    case '05':
      month = 'May'
      break
    case '06':
      month = 'Jun'
      break
    case '07':
      month = 'Jul'
      break
    case '08':
      month = 'Aug'
      break
    case '09':
      month = 'Sep'
      break
    case '10':
      month = 'Oct'
      break
    case '11':
      month = 'Nov'
      break
    case '12':
      month = 'Dec'
      break
    default:
      month = 'Jan'
  }
  return `${month} ${day}, ${year}`
}
export default function EditableTable (props) {
  const classes = useStyles()
  const [page, setPage] = React.useState(0)
  const [rowsPerPage, setRowsPerPage] = React.useState(10)
  const [modalState, setModalState] = React.useState(false)
  const [rows, setRows] = React.useState([])
  const [id, setId] = React.useState()
  const [crfNo, setCrfNo] = React.useState()

  const openAttached = arg => {
    setModalState(!modalState)
    setId(arg[0])
    setCrfNo(arg[1])
  }
  useEffect(() => {
    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_KEY}/api/inQueue?status=onGoing`,
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    }).then(response => {
      const dataRow = []
      for (let obj of response.data.data) {
        if (props.allRequests.length === 0) {
          break
        }
        props.allRequests.filter(crf => {
          if (crf.crfNo === obj.crfNo) {
            dataRow.push(
              createData(
                obj.crfNo,
                formatDate(obj.dateCreated),
                obj.amountRequested,
                obj.queueNo,
                <a
                  href={`${process.env.REACT_APP_API_KEY}/api/inQueue/display/${obj.crfNo}`}
                  target='_blank'
                >
                  {obj.queueUpload}
                </a>,
                obj.queueUpload ? (
                  <></>
                ) : props.userRole === 'Requestor' ? (
                  <button
                    type='button'
                    onClick={() => openAttached([obj._id, obj.crfNo])}
                  >
                    Attached Queue
                  </button>
                ) : (
                  <></>
                )
              )
            )
          }
        })
      }
      setRows(dataRow)
    })
  }, [])
  // const rows = [
  //   createData(
  // '100000001',
  //   '04/04/2020',
  //   '300000',
  //   'queue01',
  //   'filename.jpeg',
  //   (<button onClick={openAttached}>Attached Queue</button>)
  //   ),
  //   createData(
  //     '100000001',
  //     '04/04/2020',
  //     '300000',
  //     'n/a',
  //     'n/a',
  //     <button onClick={openAttached}>Attached Queue</button>
  //   ),
  //   createData(
  //     '100000001',
  //     '04/04/2020',
  //     '300000',
  //     'n/a',
  //     'n/a',
  //     <button onClick={openAttached}>Attached Queue</button>
  //   ),
  //   createData(
  //     '100000001',
  //     '04/04/2020',
  //     '300000',
  //     'n/a',
  //     'n/a',
  //     <button onClick={openAttached}>Attached Queue</button>
  //   )
  // ]

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value)
    setPage(0)
  }

  return (
    <Paper className={classes.root}>
      <Attached
        modalState={modalState}
        handleModal={data => openAttached(data)}
        id={id}
        crfNo={crfNo}
      />
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label='sticky table'>
          <TableHead>
            <TableRow>
              {columns.map(column => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map(row => {
                return (
                  <TableRow hover role='checkbox' tabIndex={-1} key={row.code}>
                    {columns.map(column => {
                      const value = row[column.id]
                      return (
                        <TableCell key={column.id} align={column.align}>
                          {column.format && typeof value === 'number'
                            ? column.format(value)
                            : value}
                        </TableCell>
                      )
                    })}
                  </TableRow>
                )
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component='div'
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </Paper>
  )
}
